import * as types from '../constants';

export function loadMostWidespreadTag() {
  return {
    type: types.LOAD_MOST_WIDESPREAD_TAG,
  };
}

export function loadTopTrendingTags() {
  return {
    type: types.LOAD_TOP_TRENDING_TAGS,
  };
}

export function loadFPAvg() {
  return {
    type: types.LOAD_FP_AVG,
  };
}
